import { z } from 'zod';
import { ApplicationType as ApplicationTypeEnum } from '../../graphql/operations';

export const applicationTypeSchema = z.nativeEnum(ApplicationTypeEnum);

export type ApplicationType = z.infer<typeof applicationTypeSchema>;
